import { useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import classes from './Layout.module'
import NavigationSidebar from "./NavigationSidebar";
import MainNavigation from "./MainNavigation";
import { Outlet, useLocation } from "react-router-dom";
// import AppContext from '../../contexts/app-context';
import Chatbot from "../ui/Chatbot/Chatbot";
import { AnimatePresence } from 'framer-motion';

const Layout = () => {
  const [openSidePanel, setOpenSidePanel] = useState(false);
  const [collapsed, setCollapsed] = useState(true); // collapsed by default (icons only)
  // const appCtx = useContext(AppContext);
  // const userRole = appCtx.userRole;
  const location = useLocation();

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpenSidePanel(open);
  };

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Box id='container'>
      <Box sx={classes.container}>
        {/* Desktop Sidebar - Always visible for non-patients */}
          <Box
            sx={{
              display: { xs: 'none', md: 'block' },
              height: '100vh',
              position: 'sticky',
              top: 0,
              transition: 'all 0.3s ease-in-out',
            }}
          >
            <NavigationSidebar collapsed={collapsed} onToggleCollapse={toggleSidebar} />
          </Box>

        <Box sx={classes.navbar_container}>
          <MainNavigation toggleDrawer={toggleDrawer} />
          <Box sx={classes.outlet_container}>
            <AnimatePresence mode="wait">
              <Outlet key={location.pathname} />
            </AnimatePresence>
          </Box>
        </Box>
      </Box>

      {/* Mobile Drawer */}
      <Drawer
        anchor="left"
        open={openSidePanel}
        onClose={toggleDrawer(false)}
        sx={classes.drawer}
      >
        <NavigationSidebar collapsed={false} onToggleCollapse={toggleDrawer(false)} />
      </Drawer>
      <Chatbot/>
    </Box>
  );
};

export default Layout;
